import { Button, Form, InputGroup, Modal } from 'react-bootstrap'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { MealRequestDTO } from '../../model/MealRequestDTO';
import { Meal } from '../../model/Meal';
import { Customer } from '../../model/Customer';
import { Col, Row, Switch, Tooltip } from 'antd';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {PreventMinuteSliderComponent} from "../util/PreventMinuteSliderComponent";

export const SaveEditMealModal : React.FC<{meal : Meal | null, customerList : Customer[]
    show : boolean, setShow : Dispatch<SetStateAction<boolean>>, 
    index : number | null,
    handleSaveToDatabase : (mealRequestDTO: MealRequestDTO) => Promise<() => void>
}> = (props) => {
  
    const {meal, show, setShow, index, handleSaveToDatabase} = props
    const [details, setDetails] = useState<string | undefined>()
    const [amount, setAmount] = useState<string | undefined>()
    const [active, setActive] = useState<boolean | undefined>()
    const [singlePayment, setSinglePayment] = useState<boolean | undefined>()
    const [editableForParent, setEditableForParent] = useState<boolean | undefined>()
    const [position, setPosition] = useState<string | undefined>()
    const [mealid, setMealid] = useState<number | undefined>()
    const [preventMinutes, setPreventMinutes] = useState<number>(1)
    const [errors, setErrors] = useState<Record<string, string[]>>({});

    useEffect(() => {
      setDetails(meal !== null ? meal.details : '')
      setAmount(meal !== null ? meal.amount.toString() : undefined)
      setActive(meal !== null ? meal.active : undefined)
      setSinglePayment(meal !== null ? meal.singlePayment : undefined)
      setEditableForParent(meal !== null ? meal.editableForParent : true)
      setPreventMinutes(meal !== null ? meal.preventMinutes : 1)
      setPosition(meal !== null ? meal.position.toString() : undefined)
      setMealid(meal !== null ? meal.mealid : undefined)
      setErrors({})
    // eslint-disable-next-line
    }, [show])

    const handleSetAmount = (value : string)  => {
      let tempValue = value.replace(/^0+|^-0+/, '')
      if (tempValue === '') {
        setAmount('')
      } else if (tempValue.match("^\\d{1,3}$|^-\\d{0,3}$")) {
        setAmount(tempValue)
      } else if(tempValue.match("^\\d{1,3}[.]\\d{0,2}$|-\\d{1,3}[.]\\d{0,2}$")){
        setAmount(tempValue)
      } 
    }

    const handleSetPosition = (value : string)  => {
      let tempValue = value.replace(/\D/, '')
      if (!Number.isNaN(tempValue)) {
        setPosition(tempValue)
      }
    }

    const handleExit = () => {
      setDetails(meal !== null ? meal.details : '')
      setAmount(meal !== null ? meal.amount.toString() : undefined)
      setActive(meal !== null ? meal.active : undefined)
        setEditableForParent(meal !== null ? meal.editableForParent : true)
      setPreventMinutes(meal !== null ? meal.preventMinutes : 1)
      setSinglePayment(meal !== null ? meal.singlePayment : undefined)
      setPosition(meal !== null ? meal.position.toString() : undefined)
      setMealid(meal !== null ? meal.mealid : undefined)
      setErrors({})
      setShow(false)
    }

    const handleSave = () => {
      let newValidation = validateFields()
      if (Object.values(newValidation).some((error) => error)) {
        setErrors(newValidation)
        return;
      }
      setErrors({})
      let tempMealRequestDTO = new MealRequestDTO(new Meal(
        details!, 
        parseFloat(amount!), 
        active === undefined ? true : active,  
        parseInt(position!),
        singlePayment === undefined ? false : singlePayment,
          editableForParent === undefined ? false : editableForParent,
        preventMinutes === undefined ? 1 : preventMinutes,
        meal?.customerMeals !== null ? meal?.customerMeals : [],
        mealid))
      handleSaveToDatabase(tempMealRequestDTO)
      handleExit()
      setShow(false)
    };
    
    const validateFields = () => {

      let tempErrors : Record<string, string[]> = {'details' : [], 'amount' : [], 'position' : [], 'action' : []}
      let errorsPresent = false

      if (details === null || details === undefined || details === '') {
        tempErrors.details.push('Pole opisu nie może być puste.')
        errorsPresent = true
      }
      if (details !== undefined && details?.length > 100) {
        tempErrors.details.push('Limit znaków to 100.')
        errorsPresent = true
      }

      if (amount === null || amount === undefined || amount === '') {
        tempErrors.amount.push('Należy podać kwotę.')
        errorsPresent = true
      }
      if (amount !== undefined && (parseFloat(amount) > 999.99 || parseFloat(amount) < 0)) {
        tempErrors.amount.push('Kwota może być w przedziale 0 - 999.99 zł.')
        errorsPresent = true
      }
      if (amount?.length! > 0 && isNaN(parseFloat(amount!))) {
        tempErrors.amount.push('Zły format danych. Przykładowa poprawna wartość: 12.35')
        errorsPresent = true
      }

      if (position === null || position === undefined || position === '') {
        tempErrors.position.push('Pole pozycji nie może być puste.')
        errorsPresent = true
      }
      if (position !== undefined && (parseInt(position) > 100 || parseInt(position) < 1)) {
        tempErrors.position.push('Wartość musi się mieścić w przedziale 1-100')
        errorsPresent = true
      }

      if (!errorsPresent) {
        tempErrors = {}
      }

      return tempErrors
    }

    return (
        <Modal size='xl' show={show} backdrop={'static'} onHide={() => handleExit()}>
        <Modal.Header closeButton>
          <Modal.Title>{index !== null ? 'Edytuj wzorzec posiłku' : 'Utwórz wzorzec posiłku'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="details">
              <Form.Label>Opis</Form.Label>
              <Form.Control
                type="text"
                value={details}
                placeholder="Opisz jaki to posiłek"
                onChange={(e) => setDetails(e.target.value)}
                autoFocus
                isInvalid ={errors.details?.length > 0}
                onFocus={() => errors.details = []}
              />
              {errors.details?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							</Form.Control.Feedback>
              ))}
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="amount"
            >
              <Form.Label>Kwota</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control 
                  type="text"
                  value={amount}
                  placeholder="Podaj stawkę posiłku"
                  onChange={(e) => handleSetAmount(e.target.value)}
                  isInvalid ={errors.amount?.length > 0}
                  onFocus={() => errors.amount = []}
                />
                <InputGroup.Text id="basic-addon1">zł</InputGroup.Text>
                {errors.amount?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							  </Form.Control.Feedback>
                ))}
              </InputGroup>
              
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="singlepayment"
            >
              <Form.Label>Czy kwota jest stawką dzienną, czy miesięczną</Form.Label>
              <InputGroup className="mb-3">
              <Row>
                <Col>
                <Switch
                className='px-5'
                  checkedChildren="Stawka miesięczna" 
                  unCheckedChildren="Stawka dzienna"
                  checked={singlePayment}
                  disabled={mealid !== undefined}
                  onClick={(e) => {
                      setSinglePayment(e);
                      setEditableForParent(!e)
                      if(!e) {setPreventMinutes(1)}
                  }}
                />
                </Col>
                <Col>
                <Tooltip title="Typ stawki może być ustawiony tylko przy tworzeniu nowego posiłku. Nie da się go później edytować" 
                  arrow placement="right">
                    <ErrorOutlineIcon fontSize="small" sx={{ color: '#1EAE98' }}/>
                </Tooltip>
                </Col>
              </Row>
                
                
              </InputGroup>
            </Form.Group>
              <Form.Group
                  className="mb-3"
                  controlId="viewonlyforparent"
              >
                  <Form.Label>Czy rodzic może zaznaczać i odznaczać posiłek?</Form.Label>
                  <InputGroup className="mb-3">
                      <Row>
                          <Col>
                              <Switch
                                  className='px-5'
                                  checkedChildren="Tak"
                                  unCheckedChildren="Nie"
                                  checked={editableForParent}
                                  disabled={singlePayment}
                                  onClick={(e) => {
                                      setEditableForParent(e);
                                  }}
                              />
                          </Col>
                          <Col>
                              <Tooltip title="Rodzice mogą zaznaczać i odznaczać posiłki tylko ze stawką dzienną"
                                       arrow placement="right">
                                  <ErrorOutlineIcon fontSize="small" sx={{ color: '#1EAE98' }}/>
                              </Tooltip>
                          </Col>
                      </Row>


                  </InputGroup>
              </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="position"
            >
              <Form.Label>Pozycja</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control 
                  type="text"
                  value={position}
                  placeholder="Podaj pozycję posiłku"
                  onChange={(e) => handleSetPosition(e.target.value)}
                  isInvalid ={errors.position?.length > 0}
                  onFocus={() => errors.position = []}
                />
                {errors.position?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							  </Form.Control.Feedback>
                ))}
              </InputGroup>
              
            </Form.Group>
              <PreventMinuteSliderComponent preventMinutes={preventMinutes}
                                            setPreventMinutes={setPreventMinutes}
                                            singlePayment={singlePayment!}/>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleExit()}>
            Zamknij
          </Button>
          <Button className='button-65' variant="primary" onClick={() => handleSave()}>
            Zapisz
          </Button>
        </Modal.Footer>
      </Modal>
    )
}